export default __webpack_public_path__ + "401b5033d925b16eb080940d4d3ba952.png";